document.addEventListener("DOMContentLoaded", () => {
  const accordions = document.querySelectorAll(".accordion");
  const panels = document.querySelectorAll(".panel");

  if (accordions.length === 0 && panels.length === 0) {
    return;
  }

  accordions.forEach((accordion, index) => {
    accordion.addEventListener("click", () => {
      // Fermez tous les panneaux
      panels.forEach((panel, i) => {
        if (i !== index) {
          panel.classList.remove("active");
          panel.style.maxHeight = null;

          // Réaffiche l'icône "more" et masque "less"
          accordions[i].querySelector(".more").style.display = "inline-block";
          accordions[i].querySelector(".less").style.display = "none";
        }
      });

      // Ouvrez ou fermez le panneau actuel
      const panel = panels[index];
      if (panel.classList.contains("active")) {
        panel.classList.remove("active");
        panel.style.maxHeight = null;

        // Masque "less" et réaffiche "more"
        accordion.querySelector(".less").style.display = "none";
        accordion.querySelector(".more").style.display = "inline-block";
      } else {
        panel.classList.add("active");
        panel.style.maxHeight = panel.scrollHeight + "px";

        // Masque "more" et réaffiche "less"
        accordion.querySelector(".more").style.display = "none";
        accordion.querySelector(".less").style.display = "inline-block";
      }
    });
  });
});